{
  "settings": {
    "sections": {
      "booking": {
        "label": "نوبت‌دهی آنلاین",
        "hint": "نوبت‌گیری خودِ بیماران و روزهای مرخصی شما، در هر کلینیک"
      }
    },
    "onlineBooking": {
      "regionLabel": "نوبت‌دهی آنلاین در کلینیک‌های شما",
      "cardSubtitle": "نوبت‌گیری بیماران در اپلیکیشن بیمار و صفحهٔ شما",
      "unnamedClinic": "کلینیک بی‌نام",
      "loadFailed": "تنظیمات نوبت‌دهی آنلاین در دسترس نیست.",
      "saved": "تنظیم نوبت‌دهی آنلاین ذخیره شد.",
      "saveFailed": "ذخیرهٔ تنظیم انجام نشد؛ دوباره تلاش کنید.",
      "allow": {
        "label": "بیماران بتوانند خودشان آنلاین نوبت بگیرند",
        "impact": "اگر خاموش باشد، در اپلیکیشن بیمار و صفحهٔ شما زمانی برای نوبت آنلاین در این کلینیک نشان داده نمی‌شود. نوبت‌دهی پذیرش تغییری نمی‌کند."
      },
      "horizon": {
        "label": "تا چند روز آینده",
        "unit": "روز",
        "placeholder": "همان سقف کلینیک",
        "clinicCap": "سقف کلینیک: {{days}} روز",
        "effective": "بیماران اکنون تا {{days}} روز آینده می‌توانند نوبت بگیرند.",
        "effectiveNone": "با سقف فعلی کلینیک، بیماران فعلاً نمی‌توانند آنلاین نوبت بگیرند.",
        "capped": "عدد شما از سقف کلینیک بیشتر است؛ همان {{days}} روزِ کلینیک اعمال می‌شود.",
        "paused": "نوبت آنلاین شما در این کلینیک متوقف است.",
        "invalid": "عددی بین ۱ تا ۳۶۵ وارد کنید، یا خالی بگذارید تا سقف کلینیک اعمال شود."
      },
      "warnings": {
        "noPresence": "ساعت حضور شما در این کلینیک ثبت نشده است؛ نوبت آنلاین نمایش داده نمی‌شود.",
        "noPresenceHint": "ساعات حضور را پذیرش کلینیک ثبت می‌کند.",
        "clinicClosed": "این کلینیک فعلاً نوبت آنلاین بیماران را نمی‌پذیرد.",
        "clinicClosedHint": "تنظیم شما از زمانی اعمال می‌شود که کلینیک نوبت آنلاین را روشن کند."
      },
      "empty": {
        "title": "عضو هیچ کلینیکی نیستید",
        "hint": "نوبت‌دهی آنلاین برای کلینیک‌هایی است که عضویت شما در آن‌ها تأیید شده است.",
        "action": "رفتن به مطب‌ها"
      },
      "daysOff": {
        "title": "روزهای مرخصی",
        "hint": "در این روزها نه بیمار و نه پذیرش نمی‌تواند برای شما در این کلینیک نوبت ثبت کند. نوبت‌هایی که از قبل ثبت شده‌اند تغییر نمی‌کنند.",
        "add": "افزودن روز مرخصی",
        "empty": "روز مرخصی آینده‌ای ثبت نشده است.",
        "emptyHint": "برای سفر، کنگره یا بیماری، روزهایی را که نیستید ثبت کنید.",
        "loadFailed": "روزهای مرخصی در دسترس نیست.",
        "wholeDay": "تمام روز",
        "hours": "{{start}} تا {{end}}",
        "range": "{{from}} تا {{to}}",
        "remove": "حذف",
        "removeAria": "حذف مرخصی {{range}}",
        "removeTitle": "حذف روز مرخصی",
        "removeBody": "مرخصی {{range}} در «{{clinic}}» حذف شود؟ پس از حذف، در این روزها دوباره می‌توان برای شما نوبت ثبت کرد.",
        "removeConfirm": "حذف کن",
        "removed": "روز مرخصی حذف شد.",
        "removeFailed": "حذف روز مرخصی انجام نشد."
      },
      "dayOff": {
        "title": "افزودن روز مرخصی",
        "subtitle": "در «{{clinic}}»",
        "from": "از تاریخ",
        "to": "تا تاریخ (اختیاری)",
        "toHint": "خالی بگذارید تا فقط همان یک روز ثبت شود.",
        "span": "مدت",
        "spanWhole": "تمام روز",
        "spanPart": "بخشی از روز",
        "start": "از ساعت",
        "end": "تا ساعت",
        "partHint": "این ساعت‌ها در همهٔ روزهای بازه اعمال می‌شود.",
        "reason": "علت (اختیاری)",
        "reasonPlaceholder": "مثلاً کنگره",
        "submit": "ثبت مرخصی",
        "saveFailed": "ثبت روز مرخصی انجام نشد.",
        "errors": {
          "from": "تاریخ شروع را انتخاب کنید.",
          "order": "تاریخ پایان نمی‌تواند پیش از تاریخ شروع باشد.",
          "range": "یک مرخصی حداکثر ۳۶۶ روز است.",
          "past": "پایان مرخصی نمی‌تواند پیش از امروز باشد.",
          "hours": "ساعت شروع باید پیش از ساعت پایان باشد."
        }
      }
    }
  },
  "errors": {
    "bff": {
      "onboarding": {
        "clinicListUnavailable": "فهرست مطب‌ها در دسترس نیست."
      },
      "onlineBooking": {
        "notMember": "شما عضو تأییدشده‌ی این کلینیک نیستید.",
        "settingsLoad": "دریافت تنظیمات نوبت‌دهی آنلاین با خطا مواجه شد",
        "settingsSave": "ذخیره تنظیمات نوبت‌دهی آنلاین با خطا مواجه شد",
        "horizonInvalid": "تعداد روز باید بین ۱ تا ۳۶۵ باشد؛ برای سقف کلینیک خالی بگذارید.",
        "invalid": "اطلاعات واردشده معتبر نیست.",
        "daysOffLoad": "دریافت روزهای مرخصی با خطا مواجه شد",
        "dayOffSave": "ثبت روز مرخصی با خطا مواجه شد",
        "dayOffRemove": "حذف روز مرخصی با خطا مواجه شد",
        "dayOffNotFound": "این روز مرخصی یافت نشد.",
        "dayOffDate": "تاریخ مرخصی معتبر نیست.",
        "dayOffOrder": "تاریخ پایان مرخصی نمی‌تواند پیش از تاریخ شروع باشد.",
        "dayOffRange": "یک مرخصی حداکثر ۳۶۶ روز است.",
        "dayOffPast": "پایان مرخصی نمی‌تواند پیش از امروز باشد.",
        "dayOffMinutes": "ساعت شروع مرخصی باید پیش از ساعت پایان آن باشد."
      }
    }
  }
}
